module.exports = "/images/oculus-9.jpg";